/* import __COLOCATED_TEMPLATE__ from './category-unread.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "span",
  classNames: ["category__badges"],
});
